export default __webpack_public_path__ + "d0cea9a945e82a754b77e8b8a12176d8.svg";